import type { CardTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import { CardText } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import { transparencyColors } from '@Components/BigBrowse/GridCardMesh/gridCardConstants';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { VideoPlane } from '@Components/BigBrowse/bb2/meshes2/cards/VideoPlane';
import { Assets } from '@Utils/AssetsStore';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';

import type { GridCardMeshProps } from '../GridCardMesh2';
import { ProductCardRounded } from '../primitives/ProductCardRounded';

export const MultiSectionFooterItemSmall = observer(
  function MultiSectionFooterItemSmall({
    item,
    onClick,
  }: GridCardMeshProps<PlaneTypes.Card_MultiSection_Footer_Item_Small>) {
    const videoData = useMemo(
      () =>
        item.data?.jumpDto.heroMedia.items.find(
          (i) => i.mediaType === 'Mp4VideoClip'
        ),
      [item]
    );

    if (videoData) {
      return (
        <VideoPlane
          position={item.worldPosition}
          size={item.size}
          src={videoData.url}
          sourceSize={{ width: videoData.width, height: videoData.height }}
        />
      );
    }

    const titleProps: CardTextProps = {
      text: item.data?.title ?? '',
      fontSize: 26,
      fontAsset: Assets.Font_Gilroy_Bold,
      anchorX: 'left',
      anchorY: 'bottom',
      textAlign: 'left',
      maxWidth: item.size.width - 10 * 2,
      position: {
        x: -item.size.width / 2 + 10,
        y: -item.size.height / 2 + 7,
      },
    };

    return (
      <ProductCardRounded
        position={item.worldPosition}
        size={item.size.width}
        imageUrl={item.data?.imageUrl}
        transparencyColor={transparencyColors[item.type]}
        onClick={onClick}
        uniqueKey={item.key!}
      >
        <CardText {...titleProps} />
      </ProductCardRounded>
    );
  }
);
